// extracted by mini-css-extract-plugin
export default {"component":"stationRoot__component___Vj2SK"};